import type { SVGProps } from 'react';
const SvgSquareParkingSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.571 4A2.574 2.574 0 0 0 4 6.571V19.43A2.574 2.574 0 0 0 6.571 22H19.43A2.574 2.574 0 0 0 22 19.429V6.57A2.574 2.574 0 0 0 19.429 4zm5.143 9h1.929c.711 0 1.286-.575 1.286-1.286 0-.71-.575-1.285-1.286-1.285h-1.929zm1.929 2.571h-1.929v1.286a1.284 1.284 0 1 1-2.571 0V9.464c0-.888.719-1.607 1.607-1.607h2.893a3.858 3.858 0 0 1 0 7.714"
    />
  </svg>
);
export default SvgSquareParkingSolid;
